import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './app.css'
import { Provider as FilterProvider } from './context/FilterContext';
import catData from './categories.json'

const root = ReactDOM.createRoot(document.getElementById('mozaico-vs-root'));
const container = document.getElementById('mozaico-visidea-vs-root');
// console.log(catData)

root.render(
  <React.StrictMode>
    {/* <App type={""}/> */}
    <FilterProvider>
      <App 
        website={container.getAttribute('website')} 
        public_token={container.getAttribute('public_token')} 
        user_id={container.getAttribute('user_id')} 
        category={container.getAttribute('category')} 
        categories={catData}
      />
    </FilterProvider>
  </React.StrictMode>
);

